export const getGridColumns = (elementCount: number): string => {
  if (elementCount === 1) return 'grid-cols-2';
  if (elementCount === 2) return 'grid-cols-2 sm:grid-cols-2';
  if (elementCount <= 4) return 'grid-cols-2 sm:grid-cols-2 lg:grid-cols-4';
  if (elementCount <= 6) return 'grid-cols-2 sm:grid-cols-2 lg:grid-cols-3';
  if (elementCount <= 8) return 'grid-cols-2 sm:grid-cols-2 lg:grid-cols-4';
  return 'grid-cols-2 sm:grid-cols-2 lg:grid-cols-4';
};
